// CONSTANTS are all caps.
const NS = 'SiteHeaderMegaMenuV2';
const CLS = 'siteHeaderMegaMenuV2';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/siteHeaderMegaMenu.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class SiteHeaderMegaMenuV2 {
	constructor($el) {
		// $el is the widget node return by the loadSiteHeaderMegaMenu function
		this.$el = $el;
	}

	init() {
		this.setSiteHeaderMegaMenu();
		this.initLanguageSwitcher();

		$('[data-tab-target]').on('click', (e) => {
			e.preventDefault();
			let target = $(e.target).closest('[data-tab-target]').attr('data-tab-target');

			$('#collapseDesktopTab').find(`${target}-tab`).trigger('click');
		});
	}

	setSiteHeaderMegaMenu() {
		// Add Some logic here
		const $wg = $(this.$el);
		const navItems = $wg.find(`${WG}siteNavItem`);

		for(let i = 0; i < navItems.length; i++) {
			$(navItems[i]).on('click', (e)=>{
				let icon = $(navItems[i]).find(`${WG}btnIcon`);

				icon.toggleClass('icon-plus icon-minus');
				icon.toggleClass('text-salmon text-white');
				$(navItems[i]).find('.siteHeaderMegaMenu-siteNavLink').toggleClass('text-white text-very-dark-grey');
				$(navItems[i]).toggleClass(' bg-white');
			});
		}
	}

	initLanguageSwitcher() {
		$(`${WG}lang-btn`).on('click', (e) => {
			$(`${WG}lang-icon`).toggleClass('icon-chevron-down icon-chevron-up');
			$(`${WG}lang-list`).toggleClass('d-none');
		});

		$(document).mouseup((e) => {
			let container = $('.siteHeaderTopBar-lang-btn'); // YOUR CONTAINER SELECTOR
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				// container.hide();
				$(`${WG}lang-icon`).addClass('icon-chevron-up');
				$(`${WG}lang-icon`).removeClass('icon-chevron-down');
				$(`${WG}lang-list`).addClass('d-none');
			}
		});
	}

	// Add more functions like on above here
}
